// extracted by mini-css-extract-plugin
export default {"heading":"ArticleList_heading__c8-cq","articlesWrapper":"ArticleList_articlesWrapper__Y0YTt","articlesGrid":"ArticleList_articlesGrid__izZW6"};